import imageBanner from './img/banner.png'
import imageArchitecture from './img/architecture.jpg'
import imageTable from './img/table.jpg'
import { ProductProps } from '../../type'
import { ProductCategory, ProductTag } from '../../enum'

export const caruscee90: ProductProps = {
  tag: ProductTag.ESS,
  category: ProductCategory.CommercialEnergyStorageSystems,
  pathName: 'carus-cee90',
  banner: imageBanner,
  title: 'Carus-CEE90',
  description:
    'System Includes: Inverter, battery trays, racks, BMS,\nEMS hardware and software, HVAC, fire suppression, isolation transformer and outdoor enclosure',
  features: [
    {
      type: 'card-list',
      content: [
        {
          icon: 'flexible',
          title: 'Flexible',
          description: [
            'All-in-one design and highly integrated',
            'Modular design with different optional parts',
            'Stardardized AC, DC modules with various combination for optimized ROI',
          ],
        },
        {
          icon: 'install',
          title: 'Easy Install',
          description: [
            'NEMA 3R / IP54 rated cabinets',
            'Parallel installation side-by-side or back-to-back',
            'Forklift or hoisting',
          ],
        },
        {
          icon: 'compatible',
          title: 'Compatible',
          description: [
            'Compatible with different battery brands.',
            'Broad battery voltage range: 350~750 Vdc',
            'Operational in Grid-tied and Off-grid modes',
            'Standard 480Vac Output for industrial',
          ],
        },
        {
          icon: 'compliance',
          title: 'Compliance',
          description: [
            'UL Certified system',
            'Global grid certified & listed PCS',
            'Compliance with global safety standards',
          ],
        },
      ],
    },
    {
      type: 'image-list',
      content: [{ images: [imageArchitecture] }],
    },
  ],
  specImages: [imageTable],
}
